<template>
  <div class="container admin-table-page">
    <!-- ===== TÍTULO ===== -->
    <div class="param-title-wrap">
      <b-button class="page-back-btn mr-2" variant="link" @click="cierraModal">
        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
      </b-button>
      <h2 class="param-title">{{ labels.title }}</h2>
    </div>

    <!-- ===== CONTENEDOR PRINCIPAL (TARJETA BLANCA) ===== -->
    <div class="admin-table-block mt-4">
      <div class="sarlaft-scroll">
        <b-row class="sarlaft-row">
          <b-col cols="12">
            <b-form id="create-form" class="sarlaft-form">
              <b-form-group>
                <!-- ============================================================ -->
                <!-- TARJETA 1: INFORMACIÓN DEL CONTRATO                           -->
                <!-- ============================================================ -->
                <div class="sarlaft-card-section">
                  <div class="sarlaft-card-header">
                    <h4 class="sarlaft-card-title">{{ labels.title }}</h4>
                  </div>
                  <div class="sarlaft-card-body">
                    <div class="sarlaft-row-grid" :style="{ '--sarlaft-columns': 4 }">
                      <div class="sarlaft-field">
                        <label>{{ labels.numeroContrato }}</label>
                        <b-form-input v-model="numeroContrato" type="number" />
                      </div>
                      <div class="sarlaft-field">
                        <label>{{ labels.arrendador }}</label>
                        <b-form-select v-model="arrendador">
                          <option value="">{{ labels.select }}</option>
                          <option v-for="tercero in listTercero" :key="tercero?.id" :value="tercero?.identificacion">{{ tercero?.nombre }}</option>
                        </b-form-select>
                      </div>
                      <div class="sarlaft-field">
                        <label>{{ labels.tipoContrato }}</label>
                        <b-form-select v-model="tipoContrato">
                          <option value="">{{ labels.select }}</option>
                          <option v-for="tpContrato in listTipoContrato" :key="tpContrato?.id" :value="tpContrato?.tipo_contrato">{{ tpContrato?.descripcion }}</option>
                        </b-form-select>
                      </div>
                      <div class="sarlaft-field">
                        <label>{{ labels.tipoActivo }}</label>
                        <b-form-select v-model="tipoActivo">
                          <option value="">{{ labels.select }}</option>
                          <option v-for="tpActivo in lstTipoActivo" :key="tpActivo?.id" :value="tpActivo">{{ tpActivo?.descripcion }}</option>
                        </b-form-select>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- FIN TARJETA 1 -->

                <!-- ============================================================ -->
                <!-- TARJETA 2: LISTADO DE ACTIVOS                                 -->
                <!-- ============================================================ -->
                <div class="sarlaft-card-section" v-if="lstSelActivos.length > 0">
                  <div class="sarlaft-card-header">
                    <h4 class="sarlaft-card-title">{{ labels.listadoActivos }}</h4>
                  </div>
                  <div class="sarlaft-card-body">
                    <div class="sarlaft-row-grid" :style="{ '--sarlaft-columns': 1 }">
                      <div class="sarlaft-field">
                        <b-form-select v-model="activosSelected" multiple>
                          <option v-for="activosSel in lstSelActivos" :key="activosSel?.id" :value="activosSel?.activo">{{ activosSel?.descripcion }}</option>
                        </b-form-select>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="lstSelActivos.length == 0" class="sarlaft-card-section">
                  <div class="sarlaft-card-body">
                    <h6 class="text-center">{{ labels.noActivDispo }}</h6>
                  </div>
                </div>
                <!-- FIN TARJETA 2 -->

                <!-- ============================================================ -->
                <!-- TARJETA 3: FECHAS                                             -->
                <!-- ============================================================ -->
                <div class="sarlaft-card-section">
                  <div class="sarlaft-card-header">
                    <h4 class="sarlaft-card-title">{{ labels.fechas }}</h4>
                  </div>
                  <div class="sarlaft-card-body">
                    <div class="sarlaft-row-grid" :style="{ '--sarlaft-columns': 2 }">
                      <div class="sarlaft-field">
                        <label>{{ labels.fechaInicial }}</label>
                        <b-form-input v-model="fechaInicial" type="date" />
                      </div>
                      <div class="sarlaft-field">
                        <label>{{ labels.fechaFinal }}</label>
                        <b-form-input v-model="fechaFinal" type="date" @focus="fgl_guardar=false" />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- FIN TARJETA 3 -->

                <!-- ============================================================ -->
                <!-- TARJETA 4: CONDICIONES DE TASA                                -->
                <!-- ============================================================ -->
                <div class="sarlaft-card-section">
                  <div class="sarlaft-card-header">
                    <h4 class="sarlaft-card-title">{{ labels.condicionesTasa }} 
                      <span class="sarlaft-cuotas-badge">{{ f_calcula_cuotas(fechaInicial,fechaFinal,30) }} (Meses)</span>
                    </h4>
                  </div>
                  <div class="sarlaft-card-body">
                    <div class="sarlaft-row-grid tasa-row" :style="{ '--sarlaft-columns': 4 }">
                      <div class="sarlaft-field">
                        <label>{{ labels.tasa }}</label>
                        <b-form-select v-model="tipoTasa" @change="valideTasa()" @focus="fgl_guardar=false">
                          <option value="">{{ labels.select }}</option>
                          <option v-for="tipTasa in listTipoTasa" :key="tipTasa?.id" :value="tipTasa?.tipo_tasa">{{ tipTasa?.descripcion }}</option>
                        </b-form-select>
                      </div>
                      <div class="sarlaft-field tasa-puntos-field">
                        <label>&nbsp;</label>
                        <div class="tasa-puntos-wrapper">
                          <span class="tasa-mas">+</span>
                          <b-form-input v-model="tasa" type="number" @focus="fgl_guardar=false" placeholder="Puntos" />
                        </div>
                      </div>
                      <div class="sarlaft-field">
                        <label>{{ labels.frecuencia }}</label>
                        <b-form-select v-model="frecuencia" @focus="fgl_guardar=false">
                          <option value="">{{ labels.select }}</option>
                          <option value="30">30 días</option>
                          <option value="60">60 días</option>
                          <option value="90">90 días</option>
                          <option value="180">180 días</option>
                          <option value="360">360 días</option>
                        </b-form-select>
                      </div>
                      <div class="sarlaft-field">
                        <label>{{ labels.modalidad }}</label>
                        <b-form-select v-model="modalidad" @focus="fgl_guardar=false">
                          <option value="">{{ labels.select }}</option>
                          <option value="A">{{ labels.anticipada }}</option>
                          <option value="V">{{ labels.vencida }}</option>
                        </b-form-select>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- FIN TARJETA 4 -->

                <!-- ============================================================ -->
                <!-- TARJETA 5: CONDICIONES CAMBIO CANON                           -->
                <!-- ============================================================ -->
                <div class="sarlaft-card-section">
                  <div class="sarlaft-card-header">
                    <h4 class="sarlaft-card-title">{{ labels.condicionesCambioCanon }}</h4>
                  </div>
                  <div class="sarlaft-card-body">
                    <div class="sarlaft-row-grid cambio-canon-row" :style="{ '--sarlaft-columns': 4 }">
                      <div class="sarlaft-field">
                        <label>{{ labels.incremento }}</label>
                        <b-form-select v-model="tasaCambCanon">
                          <option value="">{{ labels.select }}</option>
                          <option v-for="tipTasa in listTipoTasa" :key="tipTasa?.id" :value="tipTasa?.tipo_tasa">{{ tipTasa?.descripcion }}</option>
                        </b-form-select>
                      </div>
                      <div class="sarlaft-field tasa-puntos-field">
                        <label>&nbsp;</label>
                        <div class="tasa-puntos-wrapper">
                          <span class="tasa-mas">+</span>
                          <b-form-input v-model="puntAdicionCambCanon" type="number" placeholder="Puntos" />
                        </div>
                      </div>
                      <div class="sarlaft-field">
                        <label>{{ labels.periodicidadCambio }}</label>
                        <b-form-input v-model="periodCambioCambCanon" type="number" placeholder="N° meses" />
                      </div>
                      <div class="sarlaft-field meses-field">
                        <label>&nbsp;</label>
                        <div class="meses-label-wrapper">
                          <span class="meses-label">Meses</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- FIN TARJETA 5 -->

                <!-- ============================================================ -->
                <!-- TARJETA 6: CANON Y VALORES                                    -->
                <!-- ============================================================ -->
                <div class="sarlaft-card-section">
                  <div class="sarlaft-card-header">
                    <h4 class="sarlaft-card-title">{{ labels.valores }}</h4>
                  </div>
                  <div class="sarlaft-card-body">
                    <!-- Fila 1: Canon + Flujos | Valor Activo + Centro Costos -->
                    <div class="sarlaft-row-grid valores-row" :style="{ '--sarlaft-columns': 4 }">
                      <div class="sarlaft-field">
                        <label>{{ labels.canonArrendamiento }}</label>
                        <b-form-input v-model="canonArrendamiento" type="number" @blur="calculaValContrato()" @focus="fgl_guardar=false" @change="a_flujos_contrato=[]" placeholder="0" />
                      </div>
                      <div class="sarlaft-field boton-field">
                        <label>&nbsp;</label>
                        <b-button type="button" class="sarlaft-btn-action btn-flujos" @click="flujosContrato">
                          <font-awesome-icon :icon="['fas', 'chart-line']" class="mr-1" />
                          {{ labels.flujos }}
                        </b-button>
                      </div>
                      <div class="sarlaft-field valor-field">
                        <label>{{ labels.valorActivo }}</label>
                        <div class="valor-display">${{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 2})?.format(valorActivo) }}</div>
                      </div>
                      <div class="sarlaft-field boton-field">
                        <label>&nbsp;</label>
                        <b-button type="button" class="sarlaft-btn-action btn-centros" @click="addCentCost">
                          <font-awesome-icon :icon="['fas', 'building']" class="mr-1" />
                          {{ labels.addCentrosCosto }}
                        </b-button>
                      </div>
                    </div>

                    <!-- Fila 2: Valor Contrato + Validar/Crear -->
                    <div class="sarlaft-row-grid valores-row" :style="{ '--sarlaft-columns': 4 }">
                      <div class="sarlaft-field valor-field">
                        <label>{{ labels.valorContrato }}</label>
                        <div class="valor-display">${{ Intl?.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 2})?.format(valorContrato) }}</div>
                      </div>
                      <div class="sarlaft-field boton-field">
                        <label>&nbsp;</label>
                        <!-- Espacio vacío para mantener alineación -->
                      </div>
                      <div class="sarlaft-field boton-field">
                        <label>&nbsp;</label>
                        <!-- Espacio vacío para mantener alineación -->
                      </div>
                      <div class="sarlaft-field boton-field">
                        <label>&nbsp;</label>
                        <b-button v-if="fgl_guardar==false" type="button" class="sarlaft-btn-submit btn-validar" @click="validarContrato">
                          <font-awesome-icon :icon="['fas', 'check-circle']" class="mr-1" />
                          {{ labels.validar }}
                        </b-button>
                        <b-button v-else type="button" class="sarlaft-btn-submit btn-crear" @click="guardarContrato">
                          <font-awesome-icon :icon="['fas', 'save']" class="mr-1" />
                          {{ labels.crear }}
                        </b-button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- FIN TARJETA 6 -->

              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- MODALES -->
    <ModAgregarCentroCosto :modAdCentCost="showAdCentroCostos" @asignaCentCost="asignarCentCost" @cierraModal="closeModal"></ModAgregarCentroCosto>
    <ModFlujosContrato v-if="showFlujosContrato" :aFlujosContrato='a_flujos_contrato' :valor_canon='canonArrendamiento' :numero_cuotas='numero_cuotas' @flujosContratoFC="f_flujosContrato" @cierraModalFC="closeModalFC"></ModFlujosContrato>
  </div>
</template>

<script>
import Activos from '../../services/Activos';
import Contrato from '../../services/Contrato';
import Tercero from '../../services/Tercero';
import TipoActivo from '../../services/TipoActivo';
import TipoContrato from '../../services/TipoContrato';
import TipoTasa from '../../services/TipoTasas';
import Tasas from '../../services/Tasas';
import ModAgregarCentroCosto from './ModAgregarCentroCosto.vue';
import ModFlujosContrato from './ModFlujosContrato.vue';

export default {
  name: 'Crear',
  components: { ModAgregarCentroCosto, ModFlujosContrato },
  data: () => ({
    arrendador: '',
    tipoContrato: '',
    tipoActivo: '',
    activo: '',
    frecuencia: '',
    modalidad: '',
    valContrato: null,
    canonArrendamiento: null,
    fechaInicial: null,
    fechaFinal: null,
    opcionCompra: null,
    tipoTasa: '',
    tasa: '',
    listTercero: [],
    listTipoContrato: [],
    listTipoTasa: [],
    lstTipoActivo: [],
    lstSelActivos: [],
    activosSelected: [],
    listaActivos: [],
    valorActivo: 0,
    valorContrato: 0,
    obtTasa: 0,
    tasaCambCanon: '',
    puntAdicionCambCanon: '',
    periodCambioCambCanon: '',
    sinActivos: false,
    numeroContrato: '',
    fgl_guardar: false,
    showAdCentroCostos: false,
    showFlujosContrato: false,
    centrosCosto: [],
    a_flujos_contrato: [],
    numero_cuotas: 0,
  }),
  computed: {
    labels() {
      if (this.$store.state._language == "es-ES") {
        return {
          title: 'Crear Contrato',
          select: 'Seleccione...',
          save: "Guardar",
          close: "Cerrar",
          arrendador: 'Arrendador',
          tipoContrato: 'Tipo contrato',
          tipoActivo: 'Tipo activo',
          activo: 'Activo',
          listadoActivos: 'Listado activos',
          valorActivo: 'Valor activos',
          canonArrendamiento: 'Valor Canon',
          fechaInicial: 'Inicia',
          fechaFinal: 'Termina',
          fechas: 'Fechas del contrato',
          frecuencia: 'Frecuencia de pago',
          modalidad: 'Modalidad',
          tipoTasa: 'Tasa',
          tasa: 'Puntos adicionales',
          incremento: 'Incremento',
          valorContrato: 'Valor contrato',
          valores: 'Valores del contrato',
          anticipada: 'Anticipados',
          fija: 'Fija',
          vencida: 'Vencidos',
          crear: 'Crear',
          validar: 'Validar',
          flujos: 'Flujos',
          condicionesTasa: 'Condiciones de tasa',
          condicionesCambioCanon: 'Condiciones cambio canon',
          puntosAdicionales: 'Puntos adicionales',
          periodicidadCambio: 'Cada',
          noActivDispo: 'No hay activos disponibles',
          numeroContrato: 'Número',
          addCentrosCosto: 'Centro de costos'
        }
      } else {
        return {
          title: 'Create Contract',
          select: 'Select...',
          save: "Save",
          close: "Close",
          arrendador: 'Lessor',
          tipoContrato: 'Contract type',
          tipoActivo: 'Active type',
          activo: 'Active',
          listadoActivos: 'Active list',
          valorActivo: 'Active value',
          canonArrendamiento: 'Lease fee',
          fechaInicial: 'Starting date',
          fechaFinal: 'End date',
          fechas: 'Contract dates',
          frecuencia: 'Payment frequency',
          modalidad: 'Modality',
          tipoTasa: 'Rate',
          tasa: 'Additional points',
          valorContrato: 'Contract value',
          valores: 'Contract values',
          anticipada: 'Anticipated',
          fija: 'Fixed',
          vencida: 'Overdue',
          crear: 'Create',
          validar: 'Validate',
          flujos: 'Flows',
          condicionesTasa: 'Rate conditions',
          condicionesCambioCanon: 'Canon change conditions',
          puntosAdicionales: 'Additional points',
          periodicidadCambio: 'Periodicity of change',
          noActivDispo: 'There are no assets available',
          numeroContrato: 'Number',
          addCentrosCosto: 'Cost Centers'
        }
      }
    }
  },
  methods: {
    cierraModal() {
      this.$emit('cierraModal', false)
    },
    validarContrato() {
      let datosForm = [
        this.arrendador,
        this.tipoContrato,
        this.tipoActivo,
        this.frecuencia,
        this.modalidad,
        this.tipoTasa,
        this.tasa,
        this.canonArrendamiento,
        this.fechaInicial,
        this.fechaFinal,
        this.activosSelected,
      ]

      if (datosForm.includes('')) {
        this.$toast.error('Campo(s) pendiente(s) por diligenciar')
        this.fgl_guardar = false
      } else {
        this.calculaValContrato()
        this.fgl_guardar = true
      }
    },

    guardarContrato() {
      let datosForm = [
        this.arrendador,
        this.tipoContrato,
        this.tipoActivo,
        this.frecuencia,
        this.modalidad,
        this.tipoTasa,
        this.tasa,
        this.canonArrendamiento,
        this.fechaInicial,
        this.fechaFinal,
        this.activosSelected,
      ]

      if (datosForm.includes('')) {
        this.$toast.error('Campo(s) pendiente(s) por diligenciar')
        this.fgl_guardar = false
      } else {

        if (this.centrosCosto.length == 0) {
          this.$toast.error('Debe asignar los centros de costo.')
          return;
        }

        const cantidadCuotas = this.f_calcula_cuotas(
          this.fechaInicial, this.fechaFinal, this.frecuencia)

        let datos = {
          'numeroContrato': this.numeroContrato,
          'arrendador': this.arrendador,
          'tipoContrato': this.tipoContrato,
          'tipoActivo': this.tipoActivo,
          'frecuencia': this.frecuencia,
          'modalidad': this.modalidad,
          'tipoTasa': this.tipoTasa,
          'tasa': this.tasa,
          'tasaCambCanon': this.tasaCambCanon,
          'puntAdicionCambCanon': this.puntAdicionCambCanon,
          'periodCambioCambCanon': this.periodCambioCambCanon,
          'canonArrendamiento': Number(this.canonArrendamiento),
          'valContrato': Number(this.valorContrato),
          'fechaInicial': this.fechaInicial,
          'fechaFinal': this.fechaFinal,
          'listActivosSel': this.activosSelected,
          'centrosCosto': this.centrosCosto,
          'cantidadCuotas': cantidadCuotas,
          'idUser': this.$store.state.userId,
          'aFlujosContrato': this.a_flujos_contrato,
        }
        Contrato.createContrato(datos)
          .then((res) => {
            this.$toast.success(res.data.message)
            this.$router.push('consultarcontrato');
            this.fgl_guardar = false
            location.reload()
          })
          .catch((err) => {
            if (err.response.status == 400) {
              this.$toast.error(err.response.data.message)
            }
          })
      }
    },
    vpn(canon, cuotas, intereses) {
      let vpn = 0;
      for (let t = 0; t < cuotas; t++) {
        const v_canon = this.a_flujos_contrato[t].valor
        const flujoDeCaja = Number(v_canon);
        vpn += flujoDeCaja / Math.pow(1 + (intereses / 100), t + 1);
      }
      vpn = vpn.toFixed(0)
      return vpn
    },
    consultaTasa() {
      if (this.fechaInicial == "null" || this.fechaInicial == "undefined" || !this.fechaInicial) {
        return 0
      }
      let año = 0
      año = this.fechaInicial.substring(0, 4)
      if (año < 2000) {
        return 0
      }
      const datos = {
        'fechaInicial': this.fechaInicial,
        'codTasa': this.tipoTasa,
        'puntosAdicionales': this.tasa,
        'modalidad': this.modalidad,
        'frecuencia': this.frecuencia
      }
      Tasas.generarTasa(datos)
        .then((res) => {
          this.obtTasa = res.data.resultado
        })
        .catch((err) => console.log(err))
    },
    valideTasa() {
      if (this.fechaInicial == "null" || this.fechaInicial == "undefined" || !this.fechaInicial) {
        return;
      }
      if (this.tipoTasa == "null" || this.tipoTasa == "") {
        return;
      }
      const v_tipo_tasa = this.listTipoTasa.find((r_tipo_tasa) => r_tipo_tasa.tipo_tasa == this.tipoTasa)
      if (v_tipo_tasa && v_tipo_tasa.descripcion && v_tipo_tasa.descripcion.substr(0, 6) == "Zscore") {
        let cuotas = this.f_calcula_cuotas(this.fechaInicial, this.fechaFinal, 30) / 12
        let nro_cuotas = cuotas.toFixed(2)
        let proxima_cuota = cuotas.toFixed(0)
        proxima_cuota = proxima_cuota + ".00"
        const v_interpolado = this.listTipoTasa.find((r_tipo_tasa) => r_tipo_tasa.descripcion && r_tipo_tasa.descripcion.includes("Interpolado"))
        if (nro_cuotas != proxima_cuota) {
          if (v_tipo_tasa.descripcion.includes("Interpolado")) {
            return
          }
          this.tipoTasa = v_interpolado ? v_interpolado.tipo_tasa : this.tipoTasa
          this.f_tasa_interpolacion(this.fechaInicial, this.f_calcula_cuotas(this.fechaInicial, this.fechaFinal, 30))
        } else {
          proxima_cuota = proxima_cuota.replace(".00", "")
          let v_descripcion = "Zscore " + proxima_cuota + " año"
          if (proxima_cuota > "1" || proxima_cuota.length > 1) {
            v_descripcion = v_descripcion + "s"
          }
          const v_tasa_score = this.listTipoTasa.find((r_tipo_tasa) => r_tipo_tasa.descripcion == v_descripcion)
          if (v_tasa_score == undefined) {
            this.tipoTasa = v_interpolado ? v_interpolado.tipo_tasa : this.tipoTasa
            this.f_tasa_interpolacion(this.fechaInicial, this.f_calcula_cuotas(this.fechaInicial, this.fechaFinal, 30))
            return
          }
          this.tipoTasa = v_tasa_score.tipo_tasa
        }
      }
    },
    f_tasa_interpolacion(fechaInicial, cuotas) {
      Tasas.interpolacion(fechaInicial, cuotas)
        .then((res) => {
          this.tasa = res.data.tasa
        })
        .catch((err) => console.log(err))
    },
    calculaValContrato() {
      this.valorContrato = 0
      if (this.canonArrendamiento == null || this.fechaFinal == null ||
        this.fechaInicial == null || this.tipoContrato == null) {
        return
      }
      const cuotas = this.f_calcula_cuotas(this.fechaInicial, this.fechaFinal, this.frecuencia)
      if (cuotas == 0) {
        return
      }

      this.consultaTasa()
      if (this.a_flujos_contrato.length == 0) {
        for (let idx = 0; idx < cuotas; idx++) {
          this.a_flujos_contrato.push({ cuota: idx + 1, valor: this.canonArrendamiento })
        }
      }
      setTimeout(() => {
        this.valorContrato = this.vpn(this.canonArrendamiento, cuotas, this.obtTasa)
        const v_tipo_contrato = this.listTipoContrato.find((tipo) => tipo.tipo_contrato == this.tipoContrato)
        if (v_tipo_contrato && v_tipo_contrato.descripcion.toLowerCase() == "operativo") {
          this.valorContrato = this.valorActivo
        }
      }, 1000)
    },
    f_calcula_cuotas(fecha_inicial, fecha_final, frecuencia) {
      if (fecha_inicial == null || fecha_final == null || frecuencia == null) {
        return 0
      }
      const añoinicial = fecha_inicial.substring(0, 4)
      const mesinicial = fecha_inicial.substring(5, 7)
      let añofinal = fecha_final.substring(0, 4)
      const mesfinal = fecha_final.substring(5, 7)
      if (añoinicial > añofinal || añoinicial == añofinal && mesinicial >= mesfinal) {
        return 0
      }
      let cuotas = mesfinal - mesinicial

      if (cuotas < 0) {
        cuotas = 12 + cuotas
        añofinal = añofinal - 1
      }
      cuotas = cuotas + (añofinal - añoinicial) * 12
      cuotas = cuotas * 30
      cuotas = cuotas / frecuencia
      return cuotas
    },
    addCentCost() {
      this.showAdCentroCostos = true
    },
    flujosContrato() {
      if (this.canonArrendamiento == null || this.fechaFinal == null ||
        this.fechaInicial == null || this.tipoContrato == null) {
        return
      }
      this.showFlujosContrato = true
    },
    closeModal() {
      this.showAdCentroCostos = false
    },
    closeModalFC() {
      this.showFlujosContrato = false
    },
    asignarCentCost(infoCentCost) {
      this.centrosCosto = infoCentCost
    },
    f_flujosContrato(infoFlujosContrato) {
      this.a_flujos_contrato = infoFlujosContrato
      const cuotas = this.f_calcula_cuotas(this.fechaInicial, this.fechaFinal, this.frecuencia)
      this.valorContrato = this.vpn(this.canonArrendamiento, cuotas, this.obtTasa)
      const v_tipo_contrato = this.listTipoContrato.find((tipo) => tipo.tipo_contrato == this.tipoContrato)
      if (v_tipo_contrato && v_tipo_contrato.descripcion.toLowerCase() == "operativo") {
        this.valorContrato = this.valorActivo
      }
      this.showFlujosContrato = false
    }
  },
  mounted() {
    Tercero.getAllTercero()
      .then((res) => {
        this.listTercero = res.data.listTercero
      })
      .catch((err) => console.log(err))

    TipoContrato.getAllTipoContrato()
      .then((res) => {
        this.listTipoContrato = res.data.listTipoContrato
      })
      .catch((err) => console.log(err))

    TipoTasa.getAllTipoTasas()
      .then((res) => {
        this.listTipoTasa = res.data.listTipoTasas
      })
      .catch((err) => console.log(err))

    TipoActivo.getAllTipoActivo()
      .then((res) => {
        this.lstTipoActivo = res.data.listTipoActivo
      })
      .catch((err) => console.log(err))
  },
  watch: {
    tipoActivo(valNew) {
      if (valNew && valNew.tipo_activo) {
        Activos.getActivoByTipoActivo(valNew.tipo_activo)
          .then((res) => {
            this.lstSelActivos = res.data.activoByTipoAct
            this.lstSelActivos = this.lstSelActivos.filter((obj) => obj.proveedor == this.arrendador)
            const activosDisponibles = this.lstSelActivos.filter((act) => act.id_estado_activo == 1)
            this.lstSelActivos = activosDisponibles

            if (this.lstSelActivos.length != 0) {
              this.sinActivos = false
            } else {
              this.sinActivos = true
            }

          })
          .catch((err) => console.log(err))
      }
    },
    activosSelected(actSel) {
      this.valorActivo = 0
      actSel.forEach((seleccion) => {
        const v_activo = this.lstSelActivos.find((activo) => activo.activo == seleccion)
        if (v_activo != undefined) {
          this.valorActivo = parseFloat(this.valorActivo) +
            parseFloat(v_activo.valor_compra)
        }
      })
    },
  }
}
</script>

<style src="../main.css"></style>

<style scoped>
/* =================================================== */
/* ESTILOS PRINCIPALES - IGUAL QUE EL CSS DE REFERENCIA */
/* =================================================== */

/* Contenedor blanco principal */
.admin-table-block {
  width: 100%;
  border-radius: 28px;
  box-shadow: 0px 3px 5px #dcd7cc;
  border-color: #ececec;
  padding: 40px 40px 24px;
  max-width: 100% !important;
  min-height: 650px;
  background: #ffffff;
}

/* Cabecera con flecha */
.param-title-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  padding: 20px 0 0 40px;
}

.page-back-btn {
  position: absolute;
  left: 0;
  top: calc(50% + 10px);
  transform: translateY(-50%);
  color: #016690 !important;
  font-size: 28px;
  padding: 0 !important;
  line-height: 1 !important;
  box-shadow: none !important;
}

.page-back-btn:hover,
.page-back-btn:focus,
.page-back-btn:active {
  color: #016690 !important;
  text-decoration: none !important;
  box-shadow: none !important;
}

.param-title {
  margin: 0;
  font-size: 30px;
  font-weight: 700;
  font-family: "Montserrat", sans-serif;
  text-align: left;
}

/* =================================================== */
/* ESTRUCTURA DE TARJETAS - REUTILIZABLE               */
/* =================================================== */
.sarlaft-card-section {
  background: #ffffff;
  border: 1px solid #e0e6ed;
  border-radius: 10px;
  margin-bottom: 1.25rem;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s ease;
}

.sarlaft-card-section:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
}

.sarlaft-card-header {
  background: #f8f9fc;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e0e6ed;
}

.sarlaft-card-title {
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sarlaft-cuotas-badge {
  font-weight: 400;
  font-size: 0.85rem;
  color: #5a6c7d;
  background: #eef2f7;
  padding: 2px 12px;
  border-radius: 20px;
}

.sarlaft-card-body {
  padding: 1rem 1rem 0.75rem;
}

/* =================================================== */
/* SCROLL */
/* =================================================== */
.sarlaft-scroll {
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: auto;
  scrollbar-color: #7f9cbc #e7edf5;
}

.sarlaft-scroll::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

.sarlaft-scroll::-webkit-scrollbar-track {
  background: #e7edf5;
  border-radius: 999px;
}

.sarlaft-scroll::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #8ea9c7 0%, #5c7fa8 100%);
  border-radius: 999px;
  border: 2px solid #e7edf5;
}

.sarlaft-scroll::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #7f9cbc 0%, #4f739f 100%);
}

/* =================================================== */
/* GRID DE CAMPOS */
/* =================================================== */
.sarlaft-row-grid {
  display: grid;
  gap: 0.65rem 0.9rem;
  margin-bottom: 0.75rem;
  grid-template-columns: repeat(var(--sarlaft-columns, 3), minmax(0, 1fr));
}

.sarlaft-row-grid:last-child {
  margin-bottom: 0;
}

/* =================================================== */
/* CAMPOS */
/* =================================================== */
.sarlaft-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  text-align: left;
}

.sarlaft-field label {
  font-weight: 600;
  font-size: 0.85rem;
  margin: 0;
  color: #34495e;
  min-height: 20px;
}

.sarlaft-field .form-control,
.sarlaft-field .custom-select {
  width: 100%;
  min-height: 38px;
  border-radius: 8px;
  font-size: 0.9rem;
}

.sarlaft-field .form-control[multiple] {
  min-height: 80px;
}

/* =================================================== */
/* TASA - PUNTOS ADICIONALES */
/* =================================================== */
.tasa-puntos-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.tasa-puntos-wrapper {
  display: flex;
  align-items: center;
  gap: 0;
  min-height: 38px;
}

.tasa-mas {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  min-height: 38px;
  background: #f0f2f5;
  border: 1px solid #ced4da;
  border-right: none;
  border-radius: 8px 0 0 8px;
  font-size: 1.1rem;
  font-weight: 700;
  color: #495057;
  flex-shrink: 0;
}

.tasa-puntos-wrapper .form-control {
  border-radius: 0 8px 8px 0;
  min-height: 38px;
  flex: 1;
}

.tasa-puntos-wrapper .form-control:focus {
  z-index: 1;
}

/* =================================================== */
/* MESES LABEL */
/* =================================================== */
.meses-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.meses-label-wrapper {
  display: flex;
  align-items: center;
  min-height: 38px;
  padding: 0 0 0 4px;
}

.meses-label {
  font-size: 0.95rem;
  font-weight: 600;
  color: #2c3e50;
}

/* =================================================== */
/* VALORES - DISPLAY */
/* =================================================== */
.valor-field .valor-display {
  min-height: 38px;
  display: flex;
  align-items: center;
  padding: 0.25rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: #016690;
  background: #f8fafc;
  border-radius: 8px;
  padding: 0 12px;
  border: 1px solid #e9ecef;
}

/* =================================================== */
/* BOTONES DE ACCIÓN */
/* =================================================== */
.boton-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.boton-field label {
  min-height: 20px;
}

.sarlaft-btn-action,
.sarlaft-btn-submit {
  min-height: 38px;
  padding: 0.45rem 1.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}

/* Botones Flujos y Centro de costos - Gris */
.sarlaft-btn-action {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  color: #ffffff !important;
}

.sarlaft-btn-action:hover,
.sarlaft-btn-action:focus,
.sarlaft-btn-action:active {
  background-color: #5a6268 !important;
  border-color: #545b62 !important;
  color: #ffffff !important;
  box-shadow: 0 2px 8px rgba(108, 117, 125, 0.3) !important;
}

/* Botón Validar/Crear - Azul */
.sarlaft-btn-submit {
  background-color: #016690 !important;
  border-color: #016690 !important;
  color: #ffffff !important;
}

.sarlaft-btn-submit:hover,
.sarlaft-btn-submit:focus,
.sarlaft-btn-submit:active {
  background-color: #01547a !important;
  border-color: #01547a !important;
  color: #ffffff !important;
  box-shadow: 0 2px 8px rgba(1, 102, 144, 0.3) !important;
}

/* =================================================== */
/* FILAS ESPECÍFICAS */
/* =================================================== */
.tasa-row .sarlaft-field:first-child {
  grid-column: span 1;
}

.tasa-row .sarlaft-field:nth-child(2) {
  grid-column: span 1;
}

.cambio-canon-row .sarlaft-field:last-child {
  grid-column: span 1;
}

.valores-row .sarlaft-field.boton-field {
  grid-column: span 1;
}

/* =================================================== */
/* RESPONSIVE */
/* =================================================== */
@media (max-width: 992px) {
  .sarlaft-row-grid {
    grid-template-columns: repeat(2, 1fr) !important;
  }
  
  .sarlaft-field-wide {
    grid-column: 1 / -1 !important;
  }
  
  .param-title {
    font-size: 22px;
  }
  
  .admin-table-block {
    padding: 20px;
  }
}

@media (max-width: 576px) {
  .sarlaft-row-grid {
    grid-template-columns: 1fr !important;
  }
  
  .param-title-wrap {
    padding: 10px 0 0 35px;
  }
  
  .param-title {
    font-size: 18px;
  }
  
  .admin-table-block {
    padding: 15px;
  }
  
  .sarlaft-card-body {
    padding: 0.75rem;
  }
}

.sarlaft-row {
  margin: 0;
}

.sarlaft-form {
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
}
</style>
